import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/alloy-react-tooltip';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import { tooltipIconStyle } from './styles';
import { AUTOSPECS_URL } from './constants';

const AutoSpecsTooltip = ({ title, message, URLMessage }) => {
  const ToolTipContent = () => (
    <div>
      {message}
      <span>
        {' '}
        <a style={{ color: '#0696D7' }} href={AUTOSPECS_URL}>
          {URLMessage}
        </a>
      </span>
    </div>
  );
  return (
    <>
      {title}
      <Tooltip
        delayHide={1000}
        content={<ToolTipContent />}
        shouldWrapChildren={false}
        placement={Tooltip.PLACEMENTS.RIGHT}
        style={{ maxWidth: '240px' }}
      >
        <AlertInformationIcon size={16} style={tooltipIconStyle} />
      </Tooltip>
    </>
  );
};

AutoSpecsTooltip.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  URLMessage: PropTypes.string.isRequired,
};

AutoSpecsTooltip.defaultProps = {
  title: '',
};

export default AutoSpecsTooltip;
